import {
    Box,
    Typography,
    Button,
    Grid,
    useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import FloatingPointsBackground from "../../Components/FloatingPoints/FloatingPoints";
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';



const HeroSection = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const navigate = useNavigate();

    return (
        <>
            <Box
                sx={{
                    // backgroundImage: 'url("/images/homebg.png")',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    minHeight: { xs: '60vh', md: '60vh' },
                    pt: { xs: 10, md: 14 },
                    pb: { xs: 10, md: 14 },
                    px: 2,
                    color: '#fff',
                    textAlign: { xs: 'center', sm: 'left' },
                    mt: { xs: 2, md: 4 },
                    position: 'relative',
                    overflow: 'hidden',
                    zIndex: 1,
                }}
            >
                <FloatingPointsBackground />

                <Grid
                    container
                    spacing={6}
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{
                        maxWidth: '1200px',
                        mx: 'auto',
                        zIndex: 10,
                    }}
                    direction={{ xs: 'column', sm: 'row' }}
                // direction={{ xs: 'column-reverse', md: 'row' }}
                >
                    {/* Text Section */}
                    <Grid item xs={12} md={6}>
                        <Box sx={{ textAlign: { xs: 'center', sm: 'left' }, mt: { xs: 2, md: 4 } }}>
                            <Box
                                sx={{
                                    maxWidth: 500,
                                    // ml: { xs: '-10px', md: '-70px' },
                                }}>
                                <Typography
                                    variant="subtitle1"
                                    sx={{
                                        fontWeight: 'bold',
                                        fontSize: { xs: '3rem', md: '5rem' },
                                        lineHeight: 1.2,
                                        mb: 2,
                                    }}
                                >
                                    <Box component="span" display="block">Safer, better Internet</Box>
                                    <Box component="span" display="block">starts here</Box>
                                    {/* Challenge<br />Misinformation */}
                                </Typography>

                                <Typography
                                    variant="subtitle1"
                                    sx={{
                                        mb: 10,
                                        color: 'rgba(255,255,255,0.85)',
                                        fontSize: { xs: '1rem', md: '1.25rem' },
                                    }}
                                >
                                    {/* Rebuilding the public’s trust in the digital world, one user at a time. */}
                                    {/* Reclaiming the internet, one truth at a time */}
                                </Typography>

                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: { xs: 'column', sm: 'row' },
                                        gap: 2, // This is the spacing between buttons (theme spacing * 8px, so 2 = 16px)
                                        alignItems: 'center',
                                        justifyContent: { xs: 'center', md: 'flex-start' },
                                        flexWrap: 'wrap',
                                        mb: { xs: 6, md: 0 },
                                    }}
                                >
                                    {/* First Button (Quick Check) */}
                                    <Box
                                        sx={{
                                            display: 'inline-block',
                                            p: '2px',
                                            borderRadius: '40px',
                                            background: 'linear-gradient(to right, #6667D9, #53A0CA)',
                                            mb: 2,
                                        }}
                                    >
                                        <Button
                                            variant="contained"
                                            onClick={() => navigate('/quick-check')}
                                            sx={{
                                                backgroundColor: '#f0f0f0',
                                                color: '#1a1a1a',
                                                borderRadius: '40px',
                                                px: 3,
                                                py: 1.5,
                                                fontWeight: 400,
                                                fontSize: '1rem',
                                                textTransform: 'none',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 1.5,
                                                '&:hover': {
                                                    backgroundColor: '#e0e0e0',
                                                },
                                            }}
                                        >
                                            Check for Misinformation
                                            <Box
                                                component="img"
                                                src="/images/arrow.png"
                                                alt="Next arrow"
                                                sx={{ width: 35, height: 35, pl: 3 }}
                                            />
                                        </Button>
                                    </Box>

                                    {/* Second Button (Game) */}
                                    <Box
                                        sx={{
                                            display: 'inline-block',
                                            p: '2px',
                                            borderRadius: '40px',
                                            background: 'linear-gradient(to right, #D96767, #DA8B42)',
                                            mb: 3,
                                        }}
                                    >
                                        <Button
                                            variant="contained"
                                            onClick={() => navigate('/defence-game')}
                                            sx={{
                                                backgroundColor: '#fff5f5',
                                                color: '#7A1F1F',
                                                borderRadius: '40px',
                                                px: 3,
                                                py: 1.5,
                                                fontWeight: 400,
                                                fontSize: '1rem',
                                                textTransform: 'none',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 1.5,
                                                '&:hover': {
                                                    backgroundColor: '#ffeaea',
                                                },
                                            }}
                                        >
                                            Defeat the Echo Chamber in Ctrl Alt Debunk
                                            <SportsEsportsIcon sx={{ fontSize: 28, pl: 2 }} />
                                        </Button>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Grid>
                    {/* Image Section */}
                    <Grid item xs={12} sm={6}>
                        <Box
                            component="img"
                            src="/images/homepageimg.png"
                            alt="Laptop with credibility checker"
                            sx={{
                                display: { xs: 'none', sm: 'block' }, // Hide on screens <600px
                                position: 'relative',
                                width: '100%',
                                height: { sm: 300, md: 400 },         // Responsive height
                                overflow: 'hidden',
                            }}
                        />
                    </Grid>
                </Grid>
            </Box>
        </>
    );
};


export default HeroSection;